import { render, staticRenderFns } from "./retrievePwd.vue?vue&type=template&id=16b15558&scoped=true&"
import script from "./retrievePwd.vue?vue&type=script&lang=js&"
export * from "./retrievePwd.vue?vue&type=script&lang=js&"
import style0 from "./retrievePwd.vue?vue&type=style&index=0&id=16b15558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b15558",
  null
  
)

export default component.exports